import axios from "./_axios";
import { API } from "./apiEndPoints";

const GEO_BASE = `${API.COMMON_V2}geography/`;

/**
 * @param {string} country ISO 3166-1 alpha-2
 * @param {string} [q]
 * @param {{ region?: string, limit?: number }} [options]
 */
export async function searchGeographyRegions(country, q = "", options = {}) {
  return axios()({
    method: "get",
    url: `${GEO_BASE}regions/`,
    params: {
      country,
      q: q ?? "",
      limit: options.limit ?? 25,
    },
  });
}

/**
 * @param {{ country: string, q?: string, region?: string, limit?: number }} params
 */
export async function searchGeographyMetroAreas(params) {
  const { country, q = "", region, limit = 25 } = params;
  const query = { country, q, limit };
  if (region) query.region = region;
  return axios()({
    method: "get",
    url: `${GEO_BASE}metro-areas/`,
    params: query,
  });
}

/**
 * @param {{ country: string, q?: string, region?: string, limit?: number }} params
 */
export async function searchGeographyLocalUnits(params) {
  const { country, q = "", region, limit = 25 } = params;
  const query = { country, q, limit };
  if (region) query.region = region;
  return axios()({
    method: "get",
    url: `${GEO_BASE}local-units/`,
    params: query,
  });
}

/**
 * @param {string[]} refs e.g. ["region:12", "metro_area:31"]
 */
export async function resolveGeographyRefs(refs) {
  const list = (refs || []).filter(Boolean);
  if (!list.length) {
    return { data: { results: [], missing: [] } };
  }
  return axios()({
    method: "get",
    url: `${GEO_BASE}resolve/`,
    params: { refs: list.join(",") },
  });
}
